import { render, staticRenderFns } from "./TabletListHeader.vue?vue&type=template&id=74b90c76&scoped=true&lang=pug"
import script from "./TabletListHeader.vue?vue&type=script&lang=ts"
export * from "./TabletListHeader.vue?vue&type=script&lang=ts"
import style0 from "./TabletListHeader.vue?vue&type=style&index=0&id=74b90c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b90c76",
  null
  
)

export default component.exports